Ext.define('SA.view.menu.AttributeCaption', {
    alias: 'widget.menu-attribute-caption',
    extend: 'Ext.Component',

    baseCls: 'sa-report-grid-menu-caption',

    beforeMenuShow() {
        if (this.attribute === 'name') {
            this.update('Location');
        }
        else {
            let attributeLabel = SA.data.AttributesCache.getLabel(this.attribute);

            this.update(Ext.util.Format.htmlEncode(attributeLabel));
        }
    }
});